var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a3 3 0 10-1.868-5.347l-3.203-2.002c.04-.177.071-.47.071-.651 0-.182-.032-.474-.071-.651l3.203-2.002a3 3 0 10-1.06-1.696L9.867 9.653a3 3 0 100 4.694l3.203 2.002a3.62 3.62 0 00-.071.65V17a3 3 0 003 3z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/b60bb1746717c5921a75404b7d18bac4-Share.svg";
export { SvgShare as ReactComponent };